import "../lib/bootstrap-css";
import React, { useEffect, useState } from "react";
import ContactChannelIcon from "./contact-channel-icon";
import { DEFAULT_CONTACT_CLICKS_COPY } from "./contact-page-data";

const getGclidFromUrl = () => {
	if (typeof window === "undefined") return null;
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get("gclid");
};

const setGclidCookie = (gclid) => {
	if (typeof document === "undefined") return;
	document.cookie = `gclid=${gclid}; path=/; max-age=2592000`;
};

const getGclidFromCookie = () => {
	if (typeof document === "undefined") return null;
	const match = document.cookie.match(/(?:^|; )gclid=([^;]*)/);
	return match ? decodeURIComponent(match[1]) : null;
};

/**
 * @param {{ localeCopy?: typeof DEFAULT_CONTACT_CLICKS_COPY }} props
 */
export default function ContactFormClicks({ localeCopy }) {
	const c = localeCopy || DEFAULT_CONTACT_CLICKS_COPY;
	const [userName, setUserName] = useState("");
	const [gclid, setGclid] = useState(null);
	const [showNamePrompt, setShowNamePrompt] = useState(false);
	const [tempName, setTempName] = useState("");
	const [linkId, setLinkId] = useState("");

	useEffect(() => {
		import("altcha");
	}, []);

	useEffect(() => {
		if (typeof window !== "undefined") {
			const gclidFromUrl = getGclidFromUrl();
			if (gclidFromUrl) {
				setGclid(gclidFromUrl);
				setGclidCookie(gclidFromUrl);
			} else {
				const gclidFromCookie = getGclidFromCookie();
				if (gclidFromCookie) setGclid(gclidFromCookie);
			}
		}
	}, []);

	const handleClick = async (nameArg) => {
		if (!nameArg?.trim()) return;
		const trimmedName = nameArg.trim();

		try {
			if (gclid) {
				const res = await fetch("/api/gclids-clicks", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({
						gclid: gclid || null,
						linkId,
						name: trimmedName,
					}),
				});
				if (!res.ok) {
					console.warn("Lead save failed", await res.text());
				}
			}

			if (linkId === "phone") {
				window.location.href = "tel:+15862213095";
			}
			if (linkId === "email") {
				window.location.href = "mailto:info@tu.biz";
			}
			if (linkId === "whatsapp") {
				const message = encodeURIComponent(c.whatsappMessage(trimmedName));
				window.open(`https://wa.me/15866125270?text=${message}`, "_blank");
			}
		} catch (err) {
			console.error("Contact click error", err);
		}
		setLinkId("");
		setUserName("");
		setShowNamePrompt(false);
		setTempName("");
	};

	const onLinkClick = (e) => {
		e.preventDefault();
		if (userName.trim()) {
			handleClick(userName);
		} else {
			setTempName("");
			setShowNamePrompt(true);
		}
	};

	const startChannel = (id) => (e) => {
		e.preventDefault();
		setLinkId(id);
		onLinkClick(e);
	};

	const channels = [
		{ id: "phone", heading: c.phoneHeading, label: c.phoneLink },
		{ id: "whatsapp", heading: c.whatsappHeading, label: c.whatsappLink },
		{ id: "email", heading: c.emailHeading, label: c.emailLink },
	];

	return (
		<aside className="tu-contact__aside" aria-label={c.addressHeading}>
			<div className="tu-contact__aside-card">
				<h2 className="tu-contact__aside-title">{c.asideTitle}</h2>
				<ul className="tu-contact__channels">
					{channels.map((channel) => (
						<li key={channel.id}>
							<button
								type="button"
								className="tu-contact__channel"
								onClick={startChannel(channel.id)}
							>
								<span className="tu-contact__channel-icon">
									<ContactChannelIcon type={channel.id} />
								</span>
								<span className="tu-contact__channel-text">
									<strong>{channel.heading}</strong>
									<span>{channel.label}</span>
								</span>
							</button>
						</li>
					))}
				</ul>

				<div className="tu-contact__address">
					<div className="tu-contact__channel-icon">
						<ContactChannelIcon type="address" />
					</div>
					<div>
						<strong>{c.addressHeading}</strong>
						<p>
							{c.addressLine1}
							<br />
							{c.addressLine2}
							<br />
							{c.addressLine3}
						</p>
					</div>
				</div>
			</div>

			{showNamePrompt ? (
				<div className="tu-modal-backdrop" role="presentation">
					<div
						className="tu-modal"
						role="dialog"
						aria-modal="true"
						aria-labelledby="tu-contact-modal-title"
					>
						<h3 id="tu-contact-modal-title" className="tu-modal__title">
							{c.modalTitle}
						</h3>
						<p className="tu-modal__body">{c.modalBody}</p>
						<input
							type="text"
							className="form-control tu-modal__input"
							value={tempName}
							onChange={(e) => setTempName(e.target.value)}
							placeholder={c.modalPlaceholder}
							autoFocus
						/>
						<div className="tu-modal__actions">
							<button
								type="button"
								className="tu-btn tu-btn-outline"
								onClick={() => {
									setShowNamePrompt(false);
									setLinkId("");
									setTempName("");
									setUserName("");
								}}
							>
								{c.modalCancel}
							</button>
							<button
								type="button"
								className="tu-btn tu-btn-primary"
								onClick={() => {
									if (tempName.trim()) {
										const trimmed = tempName.trim();
										setUserName(trimmed);
										handleClick(trimmed);
									} else {
										alert(c.modalAlertName);
									}
								}}
							>
								{c.modalContinue}
							</button>
						</div>
					</div>
				</div>
			) : null}
		</aside>
	);
}
